import React, { Component, type JSX } from 'react';
import { events } from '../../util/Events';

interface ComponentProps {
  perPage: number;
  totalResults: number;
  limitBlocks: number;
}

/**
 * `Meer trainingen` button at the bottom of the page to
 * load more tutor location blocks
 */
export class Pagination extends Component<ComponentProps> {
  public render(): JSX.Element {
    let { totalResults, perPage, limitBlocks } = this.props;
    let pagesCount = Math.ceil(totalResults / perPage);

    return ((pagesCount !== 1)
      && <div className="search-results__pagination">
        {totalResults > limitBlocks
          && <span className="search-results__link"
            onClick={(): void => events.emit('SearchLoadMore')}
          >meer trainingen weergeven</span>
        }
      </div>);
  }
}
